import $ from 'jquery';

class Map {
    constructor(long, lat, zoom) {
        this.long = long;
        this.lat = lat;
        this.zoom = zoom;
        this.mapCanvas = $('.map-data')[0];
        this.createMap();
    }

    createMap() {
        const that = this;
        const myCenter = {
            lat: that.lat,
            lng: that.long
        }
        const mapOptions = {
            center: myCenter,
            zoom: that.zoom
        };
        
        const map = new google.maps.Map(that.mapCanvas, mapOptions);
        const marker = new google.maps.Marker({
            position: myCenter,
            animation: google.maps.Animation.BOUNCE
        });
        marker.setMap(map);
    }
}

export default Map;
